import { render, staticRenderFns } from "./WebPartFormDesigner.vue?vue&type=template&id=0072bd45&scoped=true&"
import script from "./WebPartFormDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormDesigner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartFormDesigner.vue?vue&type=style&index=0&id=0072bd45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0072bd45",
  null
  
)

export default component.exports